import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { CenterOlCommentInput } from '../../../../lib/types/models/center-ol-comment/center-ol-comment-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import DateChip from '../../../elements/date-chip'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<CenterOlCommentInput, true> & {
  updatedAt?: Date
}

export const formSchema: ZodType<CenterOlCommentInput> = z.object({
  comment: createStringSchema('Comment')
})

const OlPersonalSpaceCenterOlCommentForm = ({
  defaultValues,
  updatedAt = new Date(),
  ...validationButtonProps
}: Props) => {
  const form = useForm<CenterOlCommentInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="px-4 flex flex-col gap-3"
      >
        <div className="pt-7">
          <DateChip date={updatedAt} label={'Date'} />
        </div>
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput {...field} type="textarea" label="Comment..." />
              </FormControl>
            </FormItem>
          )}
        />

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default OlPersonalSpaceCenterOlCommentForm
